import { reactive } from 'vue';
/**
 * The app's global state: plain reactive props, read and written directly; no Vuex, no Pinia, no localStorage.
 * It replaces the legacy Vuex store (legacyStore.js) piece by piece, by the boy-scout rule.
 */
export const appState = reactive({
    /** The logged-in user's session as the server last answered it; null when logged out, and after a page reload until the session is read again */
    sessionData: null,
    /** The site the app runs as, set before the app mounts (legacyStore's updateActiveSite, which also keeps Vuex's activeSite for the legacy readers) */
    site: null,
    /** The calls running now, counted by busyWhile */
    inFlight: 0,
    /** A call is running; the screens disable their actions meanwhile */
    get busy() {
        return this.inFlight > 0;
    },
    get isLoggedIn() {
        return this.sessionData !== null;
    },
});
/** Runs a call, counted in appState.inFlight while it runs */
export async function busyWhile(call) {
    appState.inFlight += 1;
    try {
        return await call();
    }
    finally {
        appState.inFlight -= 1;
    }
}
